<payee-chip-dropdown
  [placeholder]="'Hitelező adószáma'"
  [selected]="control.value"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="control.patchValue(null)"
>
  <payee-form-field width="wide">
    <span payee-label>Hitelező adószáma</span>
    <input
      payee-input
      [formControl]="control"
      (paste)="closeAfterPaste()"
    />
  </payee-form-field>
</payee-chip-dropdown>
